import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { EditFileIcon } from 'packages/eid-icons'
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TimeConstraintDialog from '../TimeConstraintDialog'
import { useAccessRequestPolicy } from 'hooks'

const useStyles = makeStyles({
    iconButton: ({ expanded }) => ({
        borderRadius: '5px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        display: 'flex',
        marginLeft: '10px',
        paddingLeft: '0px',
        paddingRight: '0px',
        minWidth: '60px',
        paddingTop: '5px',
        paddingBottom: '5px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: expanded ? '#efeff1' : 'inherit',
        '&:hover': {
            backgroundColor: '#efeff1 !important',
        },
    }),
})

const EditTimeConstraintButton = (props) => {
    const { t } = useTranslation()
    const { refetch } = props
    const [expanded, handleExpand] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const classes = useStyles({ expanded })

    const hasAccessToRequestPolicy = useAccessRequestPolicy(
        props.item.requestPolicyId,
    )

    return (
        <>
            {hasAccessToRequestPolicy ? (
                <Box>
                    <TimeConstraintDialog
                        anchorEl={anchorEl}
                        expanded={expanded}
                        data={props.item}
                        id={props.id}
                        requestPolicyData={hasAccessToRequestPolicy}
                        handleExpand={(e) => handleExpand(e)}
                        refetch={refetch}
                    />
                    <Box
                        onClick={(e) => {
                            handleExpand(!expanded)
                            setAnchorEl(e.currentTarget)
                        }}
                    >
                        <iconButton className={classes.iconButton}>
                            <EditFileIcon />
                            {t('EditTimeConstraint')}
                        </iconButton>
                    </Box>
                </Box>
            ) : (
                <></>
            )}
        </>
    )
}

export default EditTimeConstraintButton
